module.exports = __webpack_public_path__ + "media/images/review/ico-follow-s-8b11610c4ff140f2ab54d40701d77499.svg";